import axiosClient from "../../../../api/apiClient";

export const APIPostExternalFinishTest = (data: object) => {
    return axiosClient.post(`${process.env.REACT_APP_API}/external/answers/`, data);
};

export const APIPostFinishTest = (data: object) => {
    return axiosClient.post(`/tests/finished/`, data);
};